(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Mura", [], factory);
	else if(typeof exports === 'object')
		exports["Mura"] = factory();
	else
		root["Mura"] = factory();
})(self, function() {
return 